<template>
  <div class="wrapper" v-dragscroll>
  <div class="right">
  <a href="http://pfotenpiloten.org/" target="_blank"><img src="/img/untermenu/pfotenpiloten.png"></a>
  <a href="https://www.aktion-mensch.de/lotterie/jahreslos" target="_blank"><img src="/img/untermenu/aktionmensch.png"></a>
  </div>
  </div>
</template>

<style scoped>
.wrapper{
  display:none;
}

.right{float: right;}

@media (orientation: landscape) and (max-width: 980px) {
  .wrapper{
    display:block;
    margin-top:-71px;
    margin-left:0px;
    right:0;
  }
}

@media all and (min-width: 981px) {
  .wrapper{
    display:block;
    margin-top:0px;
  }
}
.wrapper img{
  width:90px;
}

.wrapper a{
}

</style>

<script>
export default {
  name: 'Untermenu',
}
</script>
